// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3fRff","content":"GlobalSearch_content__2TPat"};